import ApiService from "../api.services";
import { RequestError } from "../users/user.services";

const InvoicesService = {
  list: async function(
    user,
    branch,
    filterBy,
    startedAt,
    finishedAt,
    companyId
  ) {
    try {
      const data = {
        params: {
          user,
          branch,
          startedAt,
          finishedAt,
          filterBy,
          companyId
        }
      };
      const response = await ApiService.post(`/invoices/range`, data);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  types: async function() {
    try {
      const response = await ApiService.get(`/relations/types`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  species: async function() {
    try {
      const response = await ApiService.get(`/relations/species`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  purchase: async function(federalId, companyId) {
    const queryFederalId = federalId ? `clientFederalId=${federalId}` : "";
    const queryCompanyId = companyId ? `companyId=${companyId}` : "";
    const query = `?${queryFederalId}&${queryCompanyId}`;
    try {
      const response = await ApiService.get(`/purchase${query}`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  get: async function(id) {
    try {
      const response = await ApiService.get(`/invoices/${id}`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  add: async function(
    invoice,
    contact,
    serie,
    issueAt,
    type,
    kind,
    request,
    files,
    items,
    federalId,
    federalName,
    companyId,
    payload
  ) {
    let token = "";
    if (files) {
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append(`files`, files[i].raw);
      }
      const response = await ApiService.post("/invoices/upload", formData, {
        "Content-Type": "multipart/form-data"
      });
      token = response.data;
    }
    try {
      const data = {
        invoice: {
          invoice,
          contact,
          serie,
          issueAt,
          type,
          kind,
          token,
          items,
          request,
          federalId,
          federalName,
          companyId,
          payload
        }
      };
      const res = await ApiService.post("/invoices", data);
      return res.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  update: async function({
    id,
    invoice,
    contact,
    serie,
    issueAt,
    type,
    kind,
    files,
    items,
    status,
    error,
    messageStatus,
    payload
  }) {
    let token = "";
    if (files) {
      let formData = new FormData();
      let hasNewFile = false;
      for (let i = 0; i < files.length; i++) {
        if (files[i].raw) {
          hasNewFile = true;
          formData.append(`files`, files[i].raw);
        }
      }
      if (hasNewFile) {
        const response = await ApiService.put(
          `/invoices/upload/${id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
        token = response.data;
      }
    }
    const data = {
      invoice: {
        status,
        error,
        messageStatus,
        invoice,
        contact,
        serie,
        issueAt,
        type,
        kind,
        token,
        items,
        payload
      }
    };
    try {
      const response = await ApiService.put(`/invoices/${id}`, data);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  delete: async function(id, status) {
    const data = {
      invoice: {
        status
      }
    };
    try {
      const response = await ApiService.delete(`/invoices/${id}`, data);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  }
};

export default InvoicesService;

export { InvoicesService };
